export default __webpack_public_path__ + "static/media/alpha-dashboard-doc-analysis.ad74a446.png";